export enum Role {
  Owner = 3,
  Manager = 2,
  User = 1,
}

export enum TwilioSettings {
  AccountSid = "AccountSid",
  APIKey = "APIKey",
  WorkspaceSid = "WorkspaceSid",
  ApplicationSid = "ApplicationSid",
  WorkerTransferWorkflowSid = "WorkerTransferWorkflowSid",
  CallerId = "CallerId",
}

export enum AuthType {
  Oauth = "oauth2",
  Password = "password",
}

export enum TicketType {
  Task = 0,
  Incident = 1,
  Problem = 2,
  Question = 3,
}

export enum Priority {
  Urgent = 0,
  High = 1,
  Normal = 2,
  Low = 3,
}

export enum TicketStatus {
  New = 0,
  Open = 1,
  Closed = 2,
  Pending = 3,
  Solved = 4,
  Hold = 5,
  Deleted = 6,
}

export enum SortBy {
  Relevance = 0,
  CreatedAt = 1,
  UpdateAt = 2,
  Priority = 3,
  Status = 4,
  TicketType = 5,
  DeletedAt = 6,
}

export enum SortOrder {
  Asc = 0,
  Desc = 1,
}

export enum PhoneType {
  DEFAULT = 1,
  DDI = 2,
  MOBILE = 3,
  FAX = 4,
}

export enum AddressType {
  POBOX = 1,
  STREET = 2,
  DELIVERY = 3,
}

export enum CurrencyCode {
  AED = 1,
  AFN = 2,
  ALL = 3,
  AMD = 4,
  ANG = 5,
  AOA = 6,
  ARS = 7,
  AUD = 8,
  AWG = 9,
  AZN = 10,
  BAM = 11,
  BBD = 12,
  BDT = 13,
  BGN = 14,
  BHD = 15,
  BIF = 16,
  BMD = 17,
  BND = 18,
  BOB = 19,
  BRL = 20,
  BSD = 21,
  BTN = 22,
  BWP = 23,
  BYN = 24,
  BZD = 25,
  CAD = 26,
  CDF = 27,
  CHF = 28,
  CLP = 29,
  CNY = 30,
  COP = 31,
  CRC = 32,
  CUC = 33,
  CUP = 34,
  CVE = 35,
  CZK = 36,
  DJF = 37,
  DKK = 38,
  DOP = 39,
  DZD = 40,
  EGP = 41,
  ERN = 42,
  ETB = 43,
  EUR = 44,
  FJD = 45,
  FKP = 46,
  GBP = 47,
  GEL = 48,
  GGP = 49,
  GHS = 50,
  GIP = 51,
  GMD = 52,
  GNF = 53,
  GTQ = 54,
  GYD = 55,
  HKD = 56,
  HNL = 57,
  HRK = 58,
  HTG = 59,
  HUF = 60,
  IDR = 61,
  ILS = 62,
  IMP = 63,
  INR = 64,
  IQD = 65,
  IRR = 66,
  ISK = 67,
  JEP = 68,
  JMD = 69,
  JOD = 70,
  JPY = 71,
  KES = 72,
  KGS = 73,
  KHR = 74,
  KMF = 75,
  KPW = 76,
  KRW = 77,
  KWD = 78,
  KYD = 79,
  KZT = 80,
  LAK = 81,
  LBP = 82,
  LKR = 83,
  LRD = 84,
  LSL = 85,
  LYD = 86,
  MAD = 87,
  MDL = 88,
  MGA = 89,
  MKD = 90,
  MMK = 91,
  MNT = 92,
  MOP = 93,
  MRU = 94,
  MUR = 95,
  MVR = 96,
  MWK = 97,
  MXN = 98,
  MYR = 99,
  MZN = 100,
  NAD = 101,
  NGN = 102,
  NIO = 103,
  NOK = 104,
  NPR = 105,
  NZD = 106,
  OMR = 107,
  PAB = 108,
  PEN = 109,
  PGK = 110,
  PHP = 111,
  PKR = 112,
  PLN = 113,
  PYG = 114,
  QAR = 115,
  RON = 116,
  RSD = 117,
  RUB = 118,
  RWF = 119,
  SAR = 120,
  SBD = 121,
  SCR = 122,
  SDG = 123,
  SEK = 124,
  SGD = 125,
  SHP = 126,
  SLL = 127,
  SOS = 128,
  SPL = 129,
  SRD = 130,
  STN = 131,
  SVC = 132,
  SYP = 133,
  SZL = 134,
  THB = 135,
  TJS = 136,
  TMT = 137,
  TND = 138,
  TOP = 139,
  _TRY = 140,
  TTD = 141,
  TVD = 142,
  TWD = 143,
  TZS = 144,
  UAH = 145,
  UGX = 146,
  USD = 147,
  UYU = 148,
  UZS = 149,
  VEF = 150,
  VND = 151,
  VUV = 152,
  WST = 153,
  XAF = 154,
  XCD = 155,
  XDR = 156,
  XOF = 157,
  XPF = 158,
  YER = 159,
  ZAR = 160,
  ZMW = 161,
  ZMK = 162,
  ZWD = 163,
  _EMPTY = 164,
}

export enum XeroContactStatus {
  ACTIVE = 1,
  ARCHIVED = 2,
  GDPRREQUEST = 3,
}

export enum XeroInvoiceStatus {
  DRAFT = 1,
  SUBMITTED = 2,
  DELETED = 3,
  AUTHORISED = 4,
  PAID = 5,
  VOIDED = 6,
}

export enum TwilioTaskStatus {
  Pending = "pending",
  Reserved = "reserved",
  Assigned = "assigned",
  Canceled = "canceled",
  Completed = "completed",
  Wrapping = "wrapping",
}
